export const BASE_API_URL = 'https://srv1.leonardjke.net/api/v1/packages';
export const MODAL_TIMEOUT = 300;
